<template>
    <div>
        <div class="project-container clearfix">
            <div class="project-list">
                <div class="project-search">
                    <el-form :inline="true" :model="form" ref="formSearch" label-width="100px" class="demo-form-inline">
                        <el-form-item label="项目名称">
                            <el-input v-model="form.project_name" clearable :placeholder="$t('project.unInputProject')"></el-input>
                        </el-form-item>
                        <el-form-item label="地区">
                            <!-- <el-cascader size="large" 
                                :options="baseData.regionsData" 
                                v-model="Regions"
                                @active-item-change="handleRegionsChange"
                                clearable
                                :props="{
                                    value: 'oid',
                                    label: 'name',
                                    children: 'cities'
                                }" >
                            </el-cascader> -->
							<el-cascader size="large" clearable v-model="Regions" placeholder="请选择省市县" style="width: 100%" :options="provinceList" @active-item-change="handleItemChange" :props="props"></el-cascader>
                        </el-form-item>
                        <el-form-item label="项目负责人">
                            <el-input clearable v-model="form.project_principal_name" placeholder="请输入名字"></el-input>
                        </el-form-item>
                        <el-form-item class="fr">
							<el-button type="primary" @click="() => {$router.push('/admin')}">{{$t('btns.map')}}</el-button>
                            <el-button type="primary" @click="handleSearch">{{$t('btns.search')}}</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <el-row :gutter="20">
                    <el-col class="project-item" v-if="user.usertype < 5" :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
                        <div class="grid-content add-project" @click="() => {$router.push('/project-creating')}">
                            <div class="add-project-name">+ {{$t('project.addProject')}}</div>
                        </div>
                    </el-col>
                    <el-col class="project-item" :xs="24" :sm="12" :md="12" :lg="8" :xl="8" v-for="v in projectList" :key="v.oid">
                        <el-card :body-style="{ padding: '0px' }" class="project-card">
                           <div class="project-card-body">
                               <div class="project-card-meta">
                                   <div class="project-card-meta-avatar" @click="handleGoProject(v)">
                                       <span v-if="v.icon === ''" class="iconfont icon-yingyong-moren"></span>
                                       <img v-else :src="v.icon" alt="">
                                   </div>
                                   <div class="project-card-meta-detail">
                                       <span class="project-status normal">正常</span>
                                       <span class="project-card-title" @click="handleGoProject(v)">{{v.project_name}}</span>
                                       <span class="project-card-des" :title="v.propertyname">物业名称：{{v.property}}</span>
                                       <span class="project-card-des" :title="v.province+'/'+v.city+'/'+v.dist">所属地区：{{v.province+'/'+v.city+'/'+v.dist}}</span>
                                   </div>
                               </div>
                           </div>
                           <div class="project-card-actions">
                               <ul>
                                   <li @click.stop.prevent="editDetail(v)">
                                       <span><i class="el-icon-edit"></i>编辑</span>
                                   </li>
                                   <li @click.stop.prevent="deleteDetail(v)">
                                       <span><i class="el-icon-delete"></i>删除</span>
                                   </li>
                               </ul>
                           </div>
                        </el-card>
                    </el-col>
                </el-row>
<!--                <el-pagination v-if="project.count > pageSize" :page-size="7" background layout="prev, pager, next" :total="project.count" @current-change="currentChange">
                </el-pagination> -->
<!--               <el-pagination v-if="project.length > pageSize" :page-size="11" background layout="prev, pager, next" :total="project.count" @current-change="currentChange">
                </el-pagination>	 -->			
            </div>
        </div>
        <el-dialog :title="$t('btns.edit')" :visible.sync="dialogVisible" width="50%" class="project-form-edit">
            <project-form :editData="editData"></project-form>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import ProjectForm from "./CmpProjectForm/CmpProjectForm";
import Storage from '@/utils/storage'
import Service from '@/api/Service'
import {$Alert} from '@/utils/utils'
import { getAreaName } from '@/utils/transRegionsData';

export default {
    name: "",
    provide() {
        return {
            handleEdit: this.handleEdit
        }
    },
    data() {
        return {
            // 查询条件
            form: {
                project_name: '',
                province: '',
                city: '',
                dist: '',
				project_principal_name:'',
            },
            pagination: {
                page_num: 1,
                page_sum: 100
            },
            Regions: [],    //  地区ID
            dialogVisible: false,   //
            editData: {},   //  存储单个项目信息
            pageSize: 7,
            page: 1,
			provinceList: [],     //省市县列表
			props: {value: 'value', children: 'cities'},
        };
    },
    components: {
        // 项目表单组件
        ProjectForm
    },
    mounted() {
        let params = Object.assign({}, this.form, this.pagination)
        // 获取项目信息
        this.$store.dispatch("GetProjectList", params)

        // 获取城市区域列表
        this.$store.dispatch("getRegionsData");
    },
    computed: {
        // 项目列表
        ...mapGetters(['projectList', "baseData", "user","projectInfo"])
    },
	created() {
		this.getpro()
	},
    methods: {
		async getpro(){
			let res = await Service.getProvince();
			if(res){
			this.provinceList = res.map((e) => {
					return {value: e.oid, label: e.name, cities: []}
				});
			}
		},
        // 查询项目
        handleSearch() {
            if(this.Regions) {
                let { proviceName, cityName, areaName } = getAreaName(this.Regions, this.provinceList);  //  格式化省市区
                this.form.province= proviceName || ""
                this.form.city = cityName || ""
                this.form.dist = areaName || ""
            }
            let params = Object.assign({}, this.form, this.pagination)
            this.$store.dispatch("GetProjectList", params);
        },
        // 隐藏编辑弹框
        handleEdit() {
            this.dialogVisible = false;
            let params = Object.assign({}, this.form, this.pagination)
            // 刷新列表数据
            this.$store.dispatch("GetProjectList", params)
        },
        // 显示编辑弹框
        editDetail(v) {
            if(this.user.usertype >= 4) {
                this.$notify({
                    title: '警告',
                    message: '暂无操作权限',
                    type: 'warning'
                });
                return
            }
            this.dialogVisible = true;
            this.editData = v;
        },
        // 删除项目
        deleteDetail(v) {
            if(this.user.usertype >= 4) {
                this.$notify({
                    title: '警告',
                    message: '暂无操作权限',
                    type: 'warning'
                });
                return
            }
            $Alert(`是否确认删除 ${v.project_name} `).then( async (bool)=>{
                if(bool){
                    let data = await Service.deteleProject({ oid: v.oid });
                    if(data) {
                        this.$message({
                            message: '删除成功',
                            type: 'success',
                        });
                        // 刷新列表数据
                        let params = Object.assign({}, this.form, this.pagination)
                        this.$store.dispatch("GetProjectList", params)
                    }
                }
            });
        },
        // 进入项目
         handleGoProject(v) {
            // 设置项目ID
            Storage.set('PROJECT_OID',{project_oid:v.oid});
            Storage.set('ProjectInfo',{projectInfo:v});      //  本地缓存项目信息，减少OID获取项目信息次数
			this.$router.push({ path: "/projectsystemlist" });
        },
        currentChange(curPage) {
            const data = {
                uid: this.uid,
                pageSize: this.pageSize,
                page: curPage
            };
            this.$store.dispatch("GetProjectList", data);
        },

        // 选择地区
        handleRegionsChange(val) {
            this.$store.dispatch("getRegionsData", val);
        },
	async getPosition(val, cb) {
        let vm = this; //查询省市县
		var res
        if(!val) { //初始化加载 获取所有省份数据
			res=await Service.getProvince()
        } else if (val.length === 1) { //加载二级  获取市级数据
			res=await Service.getCity({oid: val[0]});
        } else {  //加载3级   获取县级数据
			res=await Service.getCountry({oid: val[1]});
        }
          if(!val) { //初始化加载   查询省份数据
            vm.provinceList = res.map((e) => {
              return {value: e.oid, label: e.name, cities: []}
            });
          } else if (val.length === 1) { //加载二级    查询该省下市级数据
            vm.provinceList.map((item) => {
              if(item.value === val[0]) {
                item.cities = res.map((e) => {
                  return {value: e.oid, label: e.name, cities: []}
                })
              }
            })
          } else {  //加载3级   查询该省市下县级数据
            vm.provinceList.map((item) => {
              if(item.value === val[0]) {
                item.cities.map((value) => {
                  if(value.value === val[1]){
                    value.cities = res.map((e) => {
                      return {value: e.oid, label: e.name}
                    })
                  }
                })
              }
            })
          }
          cb&&cb(res);
      },
		handleItemChange(val){
			this.getPosition(val)
		}
		
    },
};
</script>

<style>

.project-list .el-pagination {
    margin-top: 24px;
    float: right;
}
.el-dialog__header {
    text-align: left;
}
</style>

<style lang="less" scoped>
.project-item {
    margin-bottom: 20px;
	box-sizing: border-box;
    &:last-child{
        margin-bottom: 0;
    }
}
.project-card{
    background-color: #fff;
	height: 166px!improtant;
	box-sizing: border-box;
    .project-card-body{
        padding: 10px;
        overflow: hidden;
		box-sizing: border-box;
        .project-card-meta{
            overflow: hidden;
            .project-card-meta-avatar{
                margin-right: 16px;
                float: left;
                width: 48px;
                height: 48px;
                line-height: 48px;
                border-radius: 48px;
                overflow: hidden;
                img{
                    width: 100%;
                }
                span{
                    vertical-align: middle;
                    font-size: 24px;
                    color:rgba(0, 0, 0, 0.45);
                }
            }
            .project-card-meta-detail{
                margin-left: 64px;
                font-size: 0;
                color: rgba(0,0,0,.45);
                text-align: left;
                height: 100px;
                position: relative;
                span{
                    display: block;
                }
                .project-status{
                    position: absolute;
                    right: 0;
                    z-index: 9;
                    top: 0;
                    font-size: 14px;
                    line-height: 24px;
                    &::before{
                            content: "";
                            display: inline-block;
                            width: 8px;
                            height: 8px;
                            margin-right: 5px;
                            border-radius: 50%;
                            vertical-align: middle;
                        }
                    &.normal{
                        color: @primary-color;
                        &::before{
                            background-color: @primary-color;
                        }
                    }
                    &.warn{
                        color: @warning-color;
                        &::before{
                            background-color: @warning-color;
                        }
                    }
                    &.error{
                        color: @error-color;
                        &::before{
                            background-color: @error-color;
                        }
                    }
                }
                .project-card-title{
                    font-size: 16px;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    height: 42px;
                    color: rgba(0,0,0,.85);
                    font-weight: 500;
                    margin-bottom: 5px;
                    margin-right: 45px;
                    cursor: pointer;
                    &:hover{
                        color: @primary-color;
                    }
                    
                }
                .project-card-des{
                    font-size: 14px;
                    position: relative;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    width: 100%;
                    line-height: 28px;
                }
            }
        }
    }
    .project-card-actions{
        ul{
            border-top: 1px solid #e8e8e8;
            background: #f7f9fa;
            zoom: 1;
            list-style: none;
            margin: 0;
            padding: 0;
            overflow: hidden;
            li{
                width: 50%;
                float: left;
                text-align: center;
                margin: 12px 0;
                color: rgba(0,0,0,.45);
                box-sizing: border-box;
                cursor: pointer;
                &:first-child{
                    border-right: 1px solid #e8e8e8;
                }
                &:hover{
                    color: @primary-color;
                }
                i{
                    margin-right: 8px;
                }
            }
        }
    }
}

// 搜索
.project-search{
    margin:50px 0;
    text-align:left;
}
.project-list {
    max-width: 1200px;
    margin: 35px auto;
}
.project-name img {
    width: auto;
    height: 16px;
    vertical-align: middle;
}
.project-list .project-name {
    width: 100%;
    text-align: center;
}
.grid-content {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 166px!important;
    background: #fff;
    cursor: pointer;
}
.grid-content:hover {
    box-shadow: 1px 1px 2px 1px #ddd;
    color: @primary-color;
}
.add-project {
    width: 100%;
    color: rgba(0, 0, 0, 0.45);
    background-color: rgb(255, 255, 255);
}
.add-project:hover {
    border: 1px dashed @primary-color;
    box-sizing: border-box;
}
.operate-box {
    position: absolute;
    right: 10px;
    top: 8px;
}
</style>
